export class OrderMatrixSkeleton {
    init() {
        let orderMatrixSkeleton = document.querySelector('.ordermatrix-skeleton');

        if (orderMatrixSkeleton) {
            let itemRow = orderMatrixSkeleton.querySelector('.item-row'),
                numberOfItemRows = 2;

            for (let i = 0; i < numberOfItemRows; i++) {
                let clone = itemRow.cloneNode(true);

                orderMatrixSkeleton.prepend(clone);
            }
        }
    }
}
